import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

export const useSetPassword = () => {
  return useMutation({
    mutationFn: async (updatePasswordData: { currentPassword: string; newPassword: string }) => {
      await apiClient.processPasswordReset(updatePasswordData);
    },
  });
};
